import React from 'react';
import urls from '../configs/urls'
import { Redirect} from 'react-router'
import '../css/App.css';
import '../css/Address.css';
import ls from 'local-storage';
import Loading from "./Loading";
import Retry from "./Retry";
import axios from "axios";
import Address from "../Modules/Address";
import TopNav from "./TopNav";
import DialogTitle from "@material-ui/core/DialogTitle/DialogTitle";
import DialogContent from "@material-ui/core/DialogContent/DialogContent";
import DialogContentText from "@material-ui/core/DialogContentText";
import DialogActions from "@material-ui/core/DialogActions/DialogActions";
import Button from "@material-ui/core/Button";
import Dialog from "@material-ui/core/Dialog/Dialog";
import AppBody from "./AppBody";

class AddressList extends React.Component{
    list =[];
    constructor(props){
        super(props);
        this.state = {
            redirect: false,
            retry: false,
            error: false,
            error_text: "",
            loading: false,
            address_id: -1,
            addressList: [],
        };
    }

    componentDidMount = () => {

        this.getAddresses();
    };

    render() {
        let nextButton = (
            <button id={"cartSubmitButton"} onClick={()=>{this.confirmAddress()}}>تایید آدرس</button>
        );
        if(this.state.redirect)
            return (<Redirect push to={this.state.url}/>);
        if(this.state.retry)
            return (<Retry url={"/home"} type={"RELOAD"} text={"در اجرای درخواست مشکلی پیش آمده است. لطفا مجددا تلاش کنید."}/>);

        let outsideContent = (<div>
            {(window.location.href.indexOf("choose_address") > -1)?nextButton:null}
            <button id={"addAddress"} onClick={()=>{this.props.history.push('/addAddress')}}>+</button>
        </div>)
        return (
            <AppBody loading={this.state.loading} showBotNav={null} name={"لیست آدرس ها"} type={" bg-white"} outsideContent={outsideContent}>
            {this.state.addressList.map((address,index)=>{
                            let fullLines = "";
                            if(index !== this.state.addressList.length-1)
                                fullLines = (
                                    <div className={"fullLine"}>
                                        <img src={`${process.env.PUBLIC_URL}/assets/images/bin.png`} className={"deleteImg"} onClick={()=>{this.deleteAddress(address.id)}}/>
                                    </div>
                                );
                            return (
                                <div className={"addressItem"} onClick={()=>{this.setState({address_id:address.id})}}>
                                    <div className={(index%2===0)?"rightColor":"rightColor blue"}/>
                                    <div className={"addressData"}>
                                        {(index !== this.state.addressList.length-1)?<span className={"address_city_name"}>شهر : {address.city_name}</span>:""}
                                        {(index !== this.state.addressList.length-1)?<span className={"city_mahalat"}>محله : {address.mahalat_name}</span>:""}
                                        <span className={(index !== this.state.addressList.length-1)?"city_address":"city_address own"}>آدرس : {address.address}</span>
                                        <div className={"fullLine"}>
                                            <input type={"radio"} className={(window.location.href.indexOf("choose_address") > -1)?"radio":"radio hide"} checked={this.state.address_id === address.id}  onClick={()=>{this.setState({address_id:address.id})}}/>
                                        </div>
                                        {fullLines}
                                    </div>
                                </div>
                            );


                        })}

                    <Dialog
                        open={this.state.open}
                        onClose={this.handleClose}
                        aria-labelledby="alert-dialog-title"
                        aria-describedby="alert-dialog-description"
                    >
                        <DialogTitle id="alert-dialog-title">{this.state.dialogTitle}</DialogTitle>
                        <DialogContent>
                            <DialogContentText id="alert-dialog-description">
                                {this.state.dialogText}
                            </DialogContentText>
                        </DialogContent>
                        <DialogActions>
                            <Button onClick={this.handleClose} color="primary">
                                بستن
                            </Button>
                        </DialogActions>
                    </Dialog>
            </AppBody>
        );
    }

    getAddresses = ()=>{
        this.setState({loading:true});
        axios.get(urls.baseUrl+urls.getAddress+"?token="+ls.get("token"))
            .then(res => {

                if(res.data.code == 200){
                    let addressList = [];
                    res.data.address.forEach((item,index)=>{
                        let address = new Address();
                        address.setData(item);
                        addressList.push(address);
                    });

                    this.setState({
                        addressList:addressList,
                        loading:false
                    });
                }
                else{
                    this.setState({
                        open:true,
                        dialogHasConfirm:false,
                        dialogText:res.data.message,
                        dialogTitle:"خطای دریافت ارتباط با سرور.",
                        dialogType:"NONE",
                        loading:false,
                    });
                }
            })
            .catch(error => {

                this.setState({
                    open:true,
                    dialogHasConfirm:false,
                    dialogText:error.toString(),
                    dialogTitle:"خطای برقراری ارتباط با سرور.",
                    dialogType:"NONE",
                    loading:false,
                });
            });
    };
    deleteAddress = (id)=>{

        // eslint-disable-next-line no-restricted-globals
        if(confirm("آیا از حذف آدرس مطمئن هستید ؟")){
            this.setState({loading:true});
            let data = {
                token:ls.get("token"),
                id:id
            };
            axios.post(urls.baseUrl+urls.deleteAddress,data)
                .then(res => {
                    if(res.data.code == 200){
                        window.location.reload();
                    }
                    else{
                        this.setState({
                            open:true,
                            dialogHasConfirm:false,
                            dialogText:res.data.message,
                            dialogTitle:"خطا",
                            dialogType:"NONE",
                            loading:false,
                        });
                    }
                })
                .catch(error => {

                    this.setState({
                        open:true,
                        dialogHasConfirm:false,
                        dialogText:error.toString(),
                        dialogTitle:"خطای برقراری ارتباط با سرور.",
                        dialogType:"NONE",
                        loading:false,
                    });
                });
        }

    };
    handleClose  = () => {
        this.setState({open:false})
    };
    confirmAddress = ()=>{
        if(this.state.address_id == -1)
        {
            this.setState({
                open:true,
                dialogHasConfirm:false,
                dialogTitle:"آدرس لازمه !",
                dialogText:"لطفا ابتدا یک آدرس انتخاب کنید.",
                dialogType:"NONE",
                loading:false,
            });
            return;
        }

        let data = {
            id:ls.get('order_id'),
            address_id:this.state.address_id,
            is_accepted:this.state.is_accepted,
            token:ls.get("token"),
        };
        axios.post(urls.baseUrl+urls.updateOrder,data)
            .then(res => {
                if(res.data.code == 200){
                    ls.set("price",res.data.price);
                    ls.set("cash_permission",res.data.cash_permission);
                    this.props.history.push("/payment");
                }
                else{
                    this.setState({
                        open:true,
                        dialogHasConfirm:false,
                        dialogTitle:"تایید آدرس انجام نشد.",
                        dialogText:res.data.message,
                        dialogType:"NONE",
                        loading:false,
                    });
                    return;
                }
            })

    }

}



export default AddressList;
